<template>
  <div id="contact-us" class="section">
    <h1 class="title is-4">お問い合わせ</h1>
    <p class="block">Coming Soon</p>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/contact-us.scss';
</style>
